import { SnowplowService } from 'wanderu-service-analytics';

const sendEvent = (action, label, property) => SnowplowService.fireStructuredEvent({
    action,
    category: 'trip_refresh_modal',
    label,
    property,
});

const clickSkipEvent = () => sendEvent('click', 'skip');
const clickRefreshEvent = () => sendEvent('click', 'refresh');
const clickScrimEvent = () => sendEvent('click', 'scrim');
const renderModalEvent = (direction) => sendEvent('rendered', direction);

const events = {
    clickRefreshEvent,
    clickScrimEvent,
    clickSkipEvent,
    renderModalEvent,
};

export default events;
